import { render, staticRenderFns } from "./ReserveLoan.vue?vue&type=template&id=2c92df46&scoped=true&"
import script from "./ReserveLoan.vue?vue&type=script&lang=js&"
export * from "./ReserveLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c92df46",
  null
  
)

export default component.exports